/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Detail_SubtitleInputs */



/**
* | output |
* | --- |
* | "{count} customer organizations, each on its own anniversary cycle." |
*
* @param {Partner_Detail_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_subtitle = /** @type {((inputs: Partner_Detail_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Kundenorganisationen, jede in ihrem eigenen Jahrestags-Zyklus.`)
	return /** @type {LocalizedString} */ (`${i?.count} customer organizations, each on its own anniversary cycle.`)
});